import { useApiMutation } from "./use-api-mutation";

type ResendReturnRequestEmailParams = {
  returnRequestId: string;
  logId: string;
  email: string;
  /** Bypasses the 5-minute cooldown between two resends of the same entry. */
  shouldSkipCooldown?: boolean;
};

/** Superadmin route: any recipient, cooldown optional. */
export default function useResendReturnRequestEmail(shopId: string) {
  return useApiMutation(
    "post",
    "/super-admin/shops/{shopId}/return-requests/{returnRequestId}/logs/{logId}/resend-email",
    {
      // The dialog shows a translated message per error code instead.
      notify: { error: false },
      mapVariables: ({
        returnRequestId,
        logId,
        email,
        shouldSkipCooldown,
      }: ResendReturnRequestEmailParams) => ({
        params: { path: { shopId, returnRequestId, logId } },
        body: { email, shouldSkipCooldown },
      }),
    },
  );
}
